import React from 'react'
import PropTypes from 'prop-types'
import { Article } from '../components/Article'
import board3 from '../images/board3.jpg'

export function A03({ index }) {
  return (
    <Article
      index={index}
      heading="The app grows and scales with minimal effort."
      image={board3}
      imageDescription="Alice's app has gone viral!"
    >
      <div className="article-row">
        <span>
          <p>
            As CanCan continues gaining traction, the app easily scales without
            the need for additional manpower. With a secure system that by its
            very nature agrees on the state quickly, cheaply, and securely,
            making apps that can scale to large amounts of state or IO becomes
            frictionless.
            <br />
            <br />
            In CanCan's case, it's possible for the app to compete with TikTok
            and Snapchat with a developer team of five people instead of five
            thousand. The app can process petabytes of data and millions of
            requests per second with fewer than a thousand lines of code, all
            while running infinitely without constant human maintenance.
          </p>
        </span>
        <aside>
          <h4>Orthogonal Persistence</h4>
          <p>
            Orthogonal persistence is a direct result of the Internet Computer's
            canister model, where code and state live on-chain in a serverless
            environment. This eliminates a lot of the IT complexity with
            persisting data using databases (such as wiring it to your app,
            replication, sharding, etc.).
          </p>
          <h4>BigMap</h4>
          <p>
            The BigMap library is a back-end service whose scaling functionality
            is being extended to all Internet Computer applications, meaning
            exabytes of data can be easily stored and accessed on the Internet
            Computer
          </p>
        </aside>
      </div>
    </Article>
  )
}

A03.propTypes = {
  index: PropTypes.number.isRequired,
}
